export class DrawingAdditionalToursRequestDto {
    matchDay1: number;
    matchDay2: number;
    matchDay3: number;
    matchDay4: number;
    matchDay5: number;
    matchDay6: number;
    matchDay7: number;
}